const DomainUrl = `https://detac.bit68.com/en/api`;
export default DomainUrl;
